import {
  CONVERSATION_PERMISSIONS,
  ROLES,
} from 'dashboard/constants/permissions';
import { frontendURL } from '../../../helper/URLHelper';
import RecordingsIndex from './pages/RecordingsIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/recordings'),
    name: 'recordings_dashboard_index',
    component: RecordingsIndex,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
  },
];
